module.exports = __webpack_public_path__ + "static/media/verkoopadministratie.d212f835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vacatures/Overzicht/verkoopadministratie.png
// module id = 757
// module chunks = 0